import { hasContent, prettyValue } from "./formatters";

export const SELLER_STEPS = [
  { path: "/seller/welcome", label: "Welcome", key: "welcome" },
  { path: "/seller/property-details", label: "Property", key: "propertyDetails" },
  { path: "/seller/interior-features", label: "Interior", key: "interiorFeatures" },
  { path: "/seller/exterior-features", label: "Exterior", key: "exteriorFeatures" },
  { path: "/seller/upgrades", label: "Upgrades", key: "upgrades" },
  { path: "/seller/condition-notes", label: "Condition", key: "conditionNotes" },
  { path: "/seller/photos", label: "Photos", key: "photos" },
  { path: "/seller/improvements", label: "Improvements", key: "improvements" },
  { path: "/seller/listing-readiness", label: "Readiness", key: "listingReadiness" },
  { path: "/seller/tips", label: "Tips", key: "tips" },
  { path: "/seller/portfolio-summary", label: "Summary", key: "portfolioSummary" },
];

export const SELLER_SIDEBAR_KEYS = ["listingReadiness", "tips"];

export const SELLER_FRAME_STEPS = SELLER_STEPS.filter((step) => !SELLER_SIDEBAR_KEYS.includes(step.key));

export function sellerStepIndex(pathname) {
  const frame = SELLER_FRAME_STEPS.findIndex((step) => step.path === pathname);
  if (frame >= 0) return frame;
  return SELLER_STEPS.findIndex((step) => step.path === pathname);
}

export function nextSellerPath(pathname) {
  const index = SELLER_FRAME_STEPS.findIndex((step) => step.path === pathname);
  if (index < 0) return "/seller/portfolio-summary";
  return SELLER_FRAME_STEPS[Math.min(index + 1, SELLER_FRAME_STEPS.length - 1)]?.path || "/seller/portfolio-summary";
}

export function prevSellerPath(pathname) {
  const index = SELLER_FRAME_STEPS.findIndex((step) => step.path === pathname);
  if (index < 0) return "/seller/welcome";
  return SELLER_FRAME_STEPS[Math.max(index - 1, 0)]?.path || "/seller/welcome";
}

export function sellerProgress(portfolio = {}) {
  const keys = SELLER_STEPS.map((step) => step.key);
  const done = keys.filter((key) => hasContent(portfolio[key])).length;
  return {
    done,
    total: keys.length,
    percent: Math.round((done / keys.length) * 100),
  };
}

export function summarizeSellerPortfolio(portfolio = {}) {
  return SELLER_STEPS.filter((step) => step.key !== "portfolioSummary")
    .map((step) => ({
      title: step.label,
      lines: summarizeSellerSection(portfolio[step.key]).map((row) => `${row.label}: ${row.value}`),
    }))
    .filter((section) => section.lines.length);
}

export function summarizeSellerSection(value) {
  if (!hasContent(value)) return [];
  if (Array.isArray(value)) {
    return value.map((item, index) => ({
      label: `Item ${index + 1}`,
      value: typeof item === "object" ? prettyValue(item.fileName || item.description || item.caption || item) : prettyValue(item),
    }));
  }
  if (typeof value !== "object") {
    return [{ label: "Value", value: prettyValue(value) }];
  }
  return Object.entries(value)
    .filter(([, item]) => hasContent(item) && item !== false)
    .map(([key, item]) => ({
      label: prettyValue(key),
      value: Array.isArray(item)
        ? item
            .map((entry) =>
              typeof entry === "object"
                ? prettyValue(entry.fileName || entry.description || entry.caption || entry.room || "")
                : prettyValue(entry)
            )
            .filter(Boolean)
            .join(", ")
        : prettyValue(item),
    }))
    .filter((row) => row.value);
}
